export const initialState = {
  list: [],
  error: null,
  loading: false
}

export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST'
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS'
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR'

export const UPDATE_PRODUCTS_REQUEST = 'UPDATE_PRODUCTS_REQUEST'
export const UPDATE_PRODUCTS_SUCCESS = 'UPDATE_PRODUCTS_SUCCESS'
export const UPDATE_PRODUCTS_ERROR = 'UPDATE_PRODUCTS_ERROR'

export const getProductsList = (category, force = false) => (dispatch, getState, { httpRequest }) => {
  dispatch({ type: GET_PRODUCTS_REQUEST })

  const state = getState()

  if (state.products.list.length && !force) {
    dispatch({
      type: GET_PRODUCTS_SUCCESS,
      list: state.products.list
     })
     return Promise.resolve(state.products.list)
  }

  return httpRequest.get(`/products/${category || ''}`)
    .then(res => {
      dispatch({
        type: GET_PRODUCTS_SUCCESS,
        list: res.data
       })
       return Promise.resolve(res.data)
    })
    .catch(err => {
      dispatch({
        type: GET_PRODUCTS_ERROR
      })
      console.error(err)
    })
}

export const updateProducts = products => (dispatch, getState, { httpRequest }) => {
  dispatch({ type: UPDATE_PRODUCTS_REQUEST })
  return httpRequest.post(`/products`, products)
    .then(response => {
      dispatch({
        type: UPDATE_PRODUCTS_SUCCESS,
        list: response.data
      })
      return Promise.resolve(response.data)
    })
    .catch(err => {
      dispatch({
        type: UPDATE_PRODUCTS_ERROR
      })
      console.error(err)
    })
}

const ACTION_HANDLERS = {
  [GET_PRODUCTS_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [GET_PRODUCTS_SUCCESS]: (state, { list }) => ({
    ...state,
    list,
    loading: false
  }),
  [GET_PRODUCTS_ERROR]: (state, { error }) => ({
    ...state,
    error: error,
    loading: false
  }),
  [UPDATE_PRODUCTS_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [UPDATE_PRODUCTS_SUCCESS]: (state, { list }) => ({
    ...state,
    list,
    loading: false
  }),
  [UPDATE_PRODUCTS_ERROR]: (state, { error }) => ({
    ...state,
    error: error,
    loading: false
  }),
}

export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/products.js